export function validateEHNACPassword(pw) {
    return (
        // Cannot allow trimable-spaces within password!
        !(/(^\s+.*|.*?\s+$)/.test(pw)) &&
        // 8-bit safe printables (no-space)
        /^[!"%',\/0123456789:;<=>@ABCDEFGHIJKLMNOPQRSTUVWXYZ_`abcdefghijklmnopqrstuvwxyz¡¢£¤¥¦§¨©ª«¬®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ\ \#\$\&\(\)\*\+\-\.\?\[\\\]\^\{\|\}\~]{10,30}$/.test(pw) &&
        // 1 lowercase eight-bit
        /[abcdefghijklmnopqrstuvwxyzªµºßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(pw) &&
        // 1 uppercase eight-bit
        /[ABCDEFGHIJKLMNOPQRSTUVWXYZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞ]/.test(pw) &&
        // Either 1 digit or special character (8-bit)
        /[ !"%',\/0123456789:;<=>@_`¡¢£¤¥¦§¨©ª«¬®¯°±²³´µ¶·¸¹º»¼½¾¿×÷\ \#\$\&\(\)\*\+\-\.\?\[\\\]\^\{\|\}\~]/.test(pw) &&
        // Matcher fails if password contains 3 consecutive identical characters
        // https://stackoverflow.com/questions/8880088/regular-expression-to-match-3-or-more-consecutive-sequential-characters-and-cons
        // https://regex101.com/r/hxTDfr/2
        /^(?!.*(.)\1\1.*).*$/.test(pw)
    );
}

// There is one extra case in CreateNewUser of this getting rendered in a different format
export function getEHNACPasswordRequirements() {
    return "" +
        "Your password must be at least 10 characters (maximum of 30 characters)," +
        " at least one upper case letter, at least one lower case letter, at least one number" +
        " or special character. No more than two identical" +
        " characters in a row.  No leading, nor trailing spaces.";
}



// WEBPACK FOOTER //
// ./src/lib/PasswordUtils.js